/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function ClearCircle({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#ClearCircle_svg__a)"><path d="M11.424 4.576a.6.6 0 0 1 0 .848L8.85 8l2.575 2.576a.6.6 0 0 1-.848.848L8 8.85l-2.576 2.575a.6.6 0 0 1-.848-.848L7.15 8 4.576 5.424a.6.6 0 0 1 .848-.848L8 7.15l2.576-2.575a.6.6 0 0 1 .848 0" /><path fillRule="evenodd" d="M.4 8a7.6 7.6 0 1 1 15.2 0A7.6 7.6 0 0 1 .4 8M8 1.6a6.4 6.4 0 1 0 0 12.8A6.4 6.4 0 0 0 8 1.6" clipRule="evenodd" /></g><defs><clipPath id="ClearCircle_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;